import { servicesList } from "constants/services";
import * as api from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

//resend email invite to user
export const resendUserEmail = async (userID) => {
  try {
    const res = await api.resend_email_invite(userID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
  }
};
